var _defs, _rect, _rect2, _rect3, _polyline, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128.04 101.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-building,.cls-2-building{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-1-building{stroke-width:6px;}.cls-2-building{stroke-width:4.87px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-building",
    x: 90.7,
    y: 14.57,
    width: 34.34,
    height: 83.88
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-building",
    x: 3,
    y: 45.53,
    width: 34.34,
    height: 52.92
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-building",
    x: 46.88,
    y: 60.9,
    width: 34.34,
    height: 37.56
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-building",
    points: "24.17 36.28 24.17 3 58.51 3 58.51 51.1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-building",
    x: 33.38,
    y: 12.89,
    width: 2.56,
    height: 2.56
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-building",
    x: 46.05,
    y: 12.89,
    width: 2.56,
    height: 2.56
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-building",
    x: 33.38,
    y: 27.05,
    width: 2.56,
    height: 2.56
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-building",
    x: 46.05,
    y: 27.05,
    width: 2.56,
    height: 2.56
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-building",
    x: 100.25,
    y: 24.16,
    width: 2.56,
    height: 2.56
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-building",
    x: 112.93,
    y: 24.16,
    width: 2.56,
    height: 2.56
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-building",
    x: 100.25,
    y: 38.32,
    width: 2.56,
    height: 2.56
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-building",
    x: 112.93,
    y: 38.32,
    width: 2.56,
    height: 2.56
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-building",
    x: 100.25,
    y: 52.93,
    width: 2.56,
    height: 2.56
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-building",
    x: 112.93,
    y: 52.93,
    width: 2.56,
    height: 2.56
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-building",
    x: 100.25,
    y: 67.09,
    width: 2.56,
    height: 2.56
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-building",
    x: 112.93,
    y: 67.09,
    width: 2.56,
    height: 2.56
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-building",
    x: 12.55,
    y: 55.49,
    width: 2.56,
    height: 2.56
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-building",
    x: 25.22,
    y: 55.49,
    width: 2.56,
    height: 2.56
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-building",
    x: 12.55,
    y: 69.65,
    width: 2.56,
    height: 2.56
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-building",
    x: 25.22,
    y: 69.65,
    width: 2.56,
    height: 2.56
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-building",
    x: 56.44,
    y: 72.21,
    width: 2.56,
    height: 2.56
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-building",
    x: 69.11,
    y: 72.21,
    width: 2.56,
    height: 2.56
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-building",
    x: 13.53,
    y: 83.93,
    width: 12.97,
    height: 14.52
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-building",
    x: 103.6,
    y: 83.93,
    width: 8.54,
    height: 14.52
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-building",
    x: 59.78,
    y: 85.01,
    width: 8.55,
    height: 13.44
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/Building.5b931bef5800c358f0eb78218c4748e4.svg";
export { ForwardRef as ReactComponent };